/* Triple Vibe sale page: the few behaviours PageFly's runtime used to provide.
   Carousels, FAQ accordion, qty stepper, scroll-to buttons, sticky bar, native Shopify checkout. */
(function () {
  var root = document.querySelector('.tvs-root');
  if (!root) return;
  var VARIANT = root.getAttribute('data-variant');

  /* ---------- carousels (.pf-slider is native scroll-snap; add arrows + dots) ---------- */
  root.querySelectorAll('[data-tvs-type="Slideshow"]').forEach(function (show) {
    var track = show.querySelector('.pf-slider');
    if (!track) return;
    var slides = track.querySelectorAll(':scope > .pf-slide');
    var prev = show.querySelector('.pf-slider-prev');
    var next = show.querySelector('.pf-slider-next');
    var nav = show.querySelector('.pf-slider-nav');
    // stride = real distance between slide starts (slide width + gutter), not the slide width
    function step() { return slides[1] ? slides[1].offsetLeft - slides[0].offsetLeft : (slides[0] ? slides[0].offsetWidth : track.clientWidth); }
    function maxLeft() { return track.scrollWidth - track.clientWidth; }
    function pages() { return Math.max(1, Math.ceil(maxLeft() / step() - 0.05) + 1); }
    function current() { return Math.min(pages() - 1, Math.round(track.scrollLeft / step())); }
    function go(i) { track.scrollTo({ left: Math.min(Math.max(0, i) * step(), maxLeft()), behavior: 'smooth' }); }
    var dots = [];
    function buildDots() {
      if (!nav) return;
      nav.innerHTML = '';
      dots = [];
      var n = pages();
      if (n < 2) return;
      for (var i = 0; i < n; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        b.addEventListener('click', go.bind(null, i));
        nav.appendChild(b);
        dots.push(b);
      }
    }
    function sync() {
      var c = current(), n = pages();
      dots.forEach(function (d, i) { d.classList.toggle('active', i === c); });
      if (prev) prev.classList.toggle('hide', n < 2);
      if (next) next.classList.toggle('hide', n < 2);
    }
    if (prev) prev.addEventListener('click', function () { go(current() - 1 < 0 ? pages() - 1 : current() - 1); });
    if (next) next.addEventListener('click', function () { go(current() + 1 >= pages() ? 0 : current() + 1); });
    var t;
    track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(sync, 60); }, { passive: true });
    window.addEventListener('resize', function () { buildDots(); sync(); });
    buildDots();
    // review carousel: PageFly config pf-520_ = autoPlay 3000ms, loop, no pause on hover
    if (show.classList.contains('dermao-slideshow') && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var visible = false, heldUntil = 0;
      new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }).observe(track);
      ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) { track.addEventListener(ev, function () { heldUntil = Date.now() + 6000; }, { passive: true }); });
      setInterval(function () {
        if (!visible || Date.now() < heldUntil || document.hidden) return;
        go(current() + 1 >= pages() ? 0 : current() + 1);
      }, 3000);
    }
    sync();
  });

  /* ---------- FAQ accordion (one open at a time, like PageFly) ---------- */
  root.querySelectorAll('[data-tvs-type="Accordion.Header"]').forEach(function (h) {
    h.addEventListener('click', function () {
      var open = h.getAttribute('data-active') !== 'true';
      var acc = h.closest('[data-tvs-type="Accordion"]');
      acc.querySelectorAll('[data-tvs-type="Accordion.Header"]').forEach(function (o) {
        o.setAttribute('data-active', 'false');
        var i = o.querySelector('.pfa-arrow'); if (i) { i.classList.add('pfa-plus'); i.classList.remove('pfa-minus'); }
        var c = acc.querySelector('[data-id="' + o.getAttribute('data-header-id') + '"]'); if (c) c.style.display = 'none';
      });
      if (!open) return;
      h.setAttribute('data-active', 'true');
      var ic = h.querySelector('.pfa-arrow'); if (ic) { ic.classList.remove('pfa-plus'); ic.classList.add('pfa-minus'); }
      var c = acc.querySelector('[data-id="' + h.getAttribute('data-header-id') + '"]'); if (c) c.style.display = '';
    });
  });

  /* ---------- quantity stepper ---------- */
  function syncQty(input) {
    var dec = input.parentNode.querySelector('[data-quantity-action="decrease"]');
    if (dec) dec.disabled = (parseInt(input.value, 10) || 1) <= 1;
  }
  root.querySelectorAll('input[name="quantity"]').forEach(function (i) { syncQty(i); i.addEventListener('change', function () { syncQty(i); }); });
  root.querySelectorAll('[data-quantity-action]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault();
      var input = b.parentNode.querySelector('input[name="quantity"]');
      var v = parseInt(input.value, 10) || 1;
      v += b.getAttribute('data-quantity-action') === 'increase' ? 1 : -1;
      input.value = Math.min(Math.max(v, 1), 50); // variant sells when out of stock (policy continue): cap at 50, not at inventory
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* ---------- scroll-to buttons (nav links) ---------- */
  function sectionEl(id) { return root.querySelector('[data-section-id="' + id + '"]'); }
  function scrollTo(id) {
    var el = sectionEl(id); if (!el) return;
    window.scrollTo({ top: el.getBoundingClientRect().top + window.pageYOffset - 50, behavior: 'smooth' });
  }

  // buy box: top of the product section, but far enough down that the visible Add to Cart clears the sticky bar
  function buyBoxY() {
    var sec = sectionEl('pf-39a4'); if (!sec) return null;
    var y = sec.getBoundingClientRect().top + window.pageYOffset - 50;
    var atc = Array.prototype.filter.call(sec.querySelectorAll('[data-tvs-type="ProductATC2"]'), function (b) { return b.offsetParent !== null; })[0];
    if (atc) {
      var st = root.querySelector('.sticky-boy');
      var stickyH = st ? (st.offsetHeight || 56) : 0;
      y = Math.max(y, atc.getBoundingClientRect().bottom + window.pageYOffset - window.innerHeight + stickyH + 16);
    }
    return Math.round(y);
  }
  // images lazy-load during the scroll and push the buy box down, so re-measure once the scroll settles and nudge
  function scrollToBuyBox() {
    var y = buyBoxY(); if (y === null) return;
    window.scrollTo({ top: y, behavior: 'smooth' });
    var last = -1, still = 0, tries = 0;
    var t = setInterval(function () {
      var cur = Math.round(window.pageYOffset);
      still = Math.abs(cur - last) < 2 ? still + 1 : 0; last = cur;
      if (++tries > 40) return clearInterval(t);           // 8 s cap
      if (still < 2) return;                               // wait until the scroll has stopped
      clearInterval(t);
      var y2 = buyBoxY();
      if (y2 !== null && Math.abs(y2 - cur) > 4) window.scrollTo({ top: y2, behavior: 'smooth' });
    }, 200);
  }

  /* ---------- native Shopify checkout ----------
     Every buy CTA (hero, mid-page, sticky bar, product box) sends the buyer straight to Shopify checkout
     with only the Triple Vibe in the cart, at the quantity chosen in the product box (default 1).
     Cart attributes (tracking) are kept: /cart/update.js zeroes other lines instead of clearing the cart. */
  var busy = false;
  // desktop and mobile each have their own product box (one is hidden); read the one the buyer can see
  function qty() {
    var all = root.querySelectorAll('form.pf-product-form input[name="quantity"]');
    var q = Array.prototype.filter.call(all, function (i) { return i.offsetParent !== null; })[0] || all[0];
    return Math.min(Math.max(parseInt(q && q.value, 10) || 1, 1), 50);
  }
  // no browser form-restore of a stale quantity on back/forward
  root.querySelectorAll('input[name="quantity"]').forEach(function (i) { i.setAttribute('autocomplete', 'off'); });
  // Checkout = Markus's Triple Vibe buy-button link: /cart/<variant>:<qty>?channel=buy_button
  // (variant of product "triple-vibe-copy", set in the section). The ad's query string (utm_*, cmc_vid, fbclid) rides along.
  var CHECKOUT_VARIANT = root.getAttribute('data-checkout-variant') || '44991097274563';
  // ClickMagick: like /pages/sloppy-bj, cmc_vid / cmcid / fbclid ride on the cart link as attributes[...] so they land
  // on the Shopify order (note attributes) where the CM Shopify app attributes the sale. URL first, then CM's cookie.
  function val(k) {
    try {
      var q = new URLSearchParams(window.location.search).get(k); if (q) return q;
      var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + k + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : '';
    } catch (e) { return ''; }
  }
  function checkoutUrl(q) {
    // same host the buyer is on: cosara.com = USD, cosara.co.uk = GBP, ca.cosara.com = CAD (Shopify Markets by domain)
    // wand offer: the free Color Crush Wand rides along (price truth = automatic discount at checkout)
    var GIFT = root.getAttribute('data-gift-variant'), GIFT_END = Date.parse(root.getAttribute('data-gift-ends') || '');
    if (GIFT && GIFT_END && Date.now() > GIFT_END) GIFT = null; // page cached past the offer end
    var u = new URL('/cart/' + CHECKOUT_VARIANT + ':' + q + (GIFT ? ',' + GIFT + ':1' : ''), window.location.origin);
    new URLSearchParams(window.location.search).forEach(function (v, k) { u.searchParams.set(k, v); });
    u.searchParams.set('channel', 'buy_button'); u.searchParams.set('attributes[_onwardInsured]', 'false'); u.searchParams.set('attributes[_hideOnwardCheckoutExtension]', 'true');
    ['cmc_vid', 'cmcid', 'fbclid'].forEach(function (k) { var v = val(k); if (v) u.searchParams.set('attributes[' + k + ']', v); });
    return u.toString();
  }
  function checkout(e, btn) {
    if (e) { e.preventDefault(); e.stopImmediatePropagation(); }
    if (busy) return;
    busy = true;
    if (btn) { if (!btn.hasAttribute('data-tvs-label')) btn.setAttribute('data-tvs-label', btn.textContent); btn.setAttribute('aria-busy', 'true'); }
    window.location.href = checkoutUrl(qty());
  }
  // PageFly's ATC is type="button" (its runtime did the add); its data-checkout="checkout" = skip the cart, go to checkout
  root.querySelectorAll('[data-tvs-type="ProductATC2"]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      if (busy) return;
      btn.textContent = btn.getAttribute('data-adding') || btn.textContent;
      checkout(e, btn);
    });
  });
  root.querySelectorAll('form.pf-product-form').forEach(function (f) {
    f.addEventListener('submit', function (e) { checkout(e, f.querySelector('[data-tvs-type="ProductATC2"]')); });
  });
  root.querySelectorAll('[data-to-section]').forEach(function (a) {
    // every buy CTA incl. the sticky bar's SHOP NOW goes to checkout; plain nav links (FEATURES, FAQ...) scroll
    // the hero's first "SHOP 37% OFF NOW" (pf-113_) scrolls to the buy box like PageFly did; other buy CTAs go to checkout
    var scrollOnly = a.classList.contains('pf-113_');
    var buy = !scrollOnly && (!!a.closest('.sticky-boy') || /shop|buy|order|claim|off now/i.test(a.textContent || ''));
    a.addEventListener('click', function (e) {
      e.preventDefault();
      if (buy) return checkout(e, a);
      if (scrollOnly) return scrollToBuyBox();
      scrollTo(a.getAttribute('data-to-section'));
    });
  });

  // Back from checkout restores this page from bfcache with busy=true: re-arm every button
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    busy = false;
    root.querySelectorAll('[aria-busy]').forEach(function (b) { b.removeAttribute('aria-busy'); });
    root.querySelectorAll('[data-tvs-label]').forEach(function (b) { b.textContent = b.getAttribute('data-tvs-label'); });
  });

  /* ---------- product box: thumbnails pick the main image; logo link ---------- */
  root.querySelectorAll('[data-tvs-type="MediaListItem2"]').forEach(function (th) {
    th.addEventListener('click', function () {
      var box = th.closest('[data-tvs-type="ProductMedia2"]') || root;
      var main = box.querySelector('.pf-main-media .pf-media-slider');
      var slide = main && main.querySelector('[data-media-id="' + th.getAttribute('data-img-id') + '"]');
      if (!slide) return;
      main.scrollTo({ left: slide.offsetLeft - main.firstElementChild.offsetLeft, behavior: 'smooth' });
      box.querySelectorAll('[data-tvs-type="MediaListItem2"]').forEach(function (o) { o.setAttribute('data-active', o === th ? 'true' : 'false'); });
    });
  });
  root.querySelectorAll('[data-action="url"][data-href]').forEach(function (el) {
    el.style.cursor = 'pointer';
    el.addEventListener('click', function () { window.open(el.getAttribute('data-href'), el.getAttribute('data-target') || '_self'); });
  });

  /* ---------- sticky bar: shows after 2000px, like the old jQuery fadeIn/fadeOut ---------- */
  var sticky = root.querySelector('.sticky-boy');
  if (sticky) {
    var onScroll = function () { sticky.classList.toggle('tvs-show', window.pageYOffset > 2000); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
})();
